import { createContext, useContext, type ReactNode } from "react";

import { useCanAccessSurveys } from "@/surveys/hooks/useCanAccessSurveys";

// Defaults to false so a surface that renders a conversation without one of
// the providers below hides survey cards instead of linking an account
// without Surveys to a 404.
const ShowSurveyBlocksContext = createContext(false);

export function useShowSurveyBlocks(): boolean {
  return useContext(ShowSurveyBlocksContext);
}

export function SurveyBlocksAccessProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { loading, canAccess } = useCanAccessSurveys();

  return (
    <ShowSurveyBlocksContext.Provider value={!loading && canAccess}>
      {children}
    </ShowSurveyBlocksContext.Provider>
  );
}

// For support staff reviewing a conversation, who need to see every block the
// model emitted regardless of the customer's current access.
export function ShowAllSurveyBlocks({ children }: { children: ReactNode }) {
  return (
    <ShowSurveyBlocksContext.Provider value={true}>
      {children}
    </ShowSurveyBlocksContext.Provider>
  );
}
